<template>
  <div class="stamp" v-if="data.marks.length > 0">
    <div  @mouseover="toggleMarksTip()" @mouseout="toggleMarksTip()">
      <img v-for="(mark, index) in data.representiveMarks" :key="index" :src="'/assets/' + mark.path" :alt="mark.name" />
      <span v-show="data.totalCount>0">{{data.totalCount}}</span>
    </div>
    <ul v-show="data.marksTip">
      <li v-for="(mark, index) in data.summaryMarks" :key="index">ss
        <img :src="'/assets/' + mark.path" :alt="mark.name"><span>{{mark.count}}</span>
      </li>
    </ul>
  </div>
</template>
<script setup>
import axios from 'axios'
import Global from '../../js/constant.js'
import _ from 'lodash'
import { computed, defineEmits, defineProps, onMounted, reactive, watch } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toast-notification'

const $store = useStore()
const $toast = useToast()

const emits = defineEmits(['on-reloaded'])

// props
const props = defineProps({
  entryId:{
    type:Number,
    required:true
  },
  refreshFlg:{
    type:Boolean,
    required:true
  }
})
// state
const data = reactive({
  marks : [],
  representiveMarks:[],
  summaryMarks:[],
  totalCount : null,
  marksTip : false
})
// mapstate
const account = computed(() => $store.state.core.account)
// const loginFlg = computed(() => $store.state.core.loginFlg)

// mapmutation
const setClientErrors = (val) => $store.commit('setClientErrors', val)

onMounted(async () => {
  if(account.value) await get()
})
// watch
watch(account, async () => {
  await get()
})
watch(() => data.marks, async () => {
  let _summaryMarks = {}
      
  _.forEach(data.marks, (row) => {
    if (!_summaryMarks[row.mst_mark_id]) {
      _summaryMarks[row.mst_mark_id] = {
        path : row.mst_mark_path,
        name : row.mst_mark_name,
        count : 0
      }
    }
    let sumRow = _summaryMarks[row.mst_mark_id]
    sumRow['count'] = sumRow['count'] + 1
  })

  data.summaryMarks = _summaryMarks

  data.representiveMarks= _.take(Object.values(_summaryMarks), Global.mark_link_representative)

  data.totalCount = data.marks.length
})
watch(() => props.refreshFlg, async (val) => {
  if (val) {
    await get()
  }
})
//methods
const get = async () => {
  let params = { entry_id : props.entryId }
  await axios.post(Global.url.api_marks_search, params )
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      data.marks = res.data.marks
      emits('on-reloaded')
      return
    }
    setClientErrors({func:"common/entry/comment-marks.vue::get", params: params, errorMessage:JSON.stringify(res.data)})
  })
  .catch(error=>{
    $toast.error('client error')
    setClientErrors({func:"common/entry/comment-marks.vue::get", params: params, errorMessage:error})
  })
}
const toggleMarksTip = () => {
  if (data.marks== null || data.marks.length==0) {
    return
  }
  data.marksTip = !data.marksTip
}
</script>
<!-- <script>
import { mapState, mapMutations } from 'vuex'
import _ from 'lodash'

export default {
  props:{
    entryId:{
      type:Number,
      required:true
    },
    refreshFlg:{
      type:Boolean,
      required:true
    }
  },
  data () {
    return {
      marks : [],
      representiveMarks:[],
      summaryMarks:[],
      totalCount : null,
      marksTip : false
    }
  },
  watch:{
    account:function () {
      this.get()
    },
    marks:function () {
      let _summaryMarks = {}
      
      _.forEach(this.marks, (row) => {
        if (!_summaryMarks[row.mst_mark_id]) {
          _summaryMarks[row.mst_mark_id] = {
            path : row.mst_mark_path,
            name : row.mst_mark_name,
            count : 0
          }
        }
        let sumRow = _summaryMarks[row.mst_mark_id]
        sumRow['count'] = sumRow['count'] + 1
      })
      this.summaryMarks = _summaryMarks

      this.representiveMarks= _.take(Object.values(_summaryMarks), this.Global.mark_link_representative)

      this.totalCount = this.marks.length
    },
    refreshFlg:function(val){
      if (val) this.get()
    }
  },
  computed: {
    ...mapState([
      'loginFlg',
      'account'
    ]),
  },
  created: function () {
    if(this.account) this.get()
  },
  methods:{
    ...mapMutations([
      'setClientErrors'
    ]),
    get : function () {
      let params = { entry_id : this.entryId }
      this.axios.post(this.Global.url.api_marks_search, params )
      .then(res => {
        if (res.data.status == this.Global.api_status.success) {
          this.marks = res.data.marks
          this.$emit('on-reloaded')
          return
        }
        this.setClientErrors({func:"common/entry/comment-marks.vue::get", params: params, errorMessage:JSON.stringify(res.data)})
      })
      .catch(error=>{
        this.$toasted.error('client error')
        this.setClientErrors({func:"common/entry/comment-marks.vue::get", params: params, errorMessage:error})
      })
    },
    toggleMarksTip : function () {
      if (this.marks== null || this.marks.length==0) return
      this.marksTip = !this.marksTip
    },

    createSummary : function () {
      return 
    }
  }
}
</script> -->